import { render, staticRenderFns } from "./VideoFrame.vue?vue&type=template&id=59016318&scoped=true"
import script from "./VideoFrame.vue?vue&type=script&lang=js"
export * from "./VideoFrame.vue?vue&type=script&lang=js"
import style0 from "./VideoFrame.vue?vue&type=style&index=0&id=59016318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59016318",
  null
  
)

export default component.exports